import { render, staticRenderFns } from "./RouterAbout.vue?vue&type=template&id=276361cc&"
import script from "./RouterAbout.vue?vue&type=script&lang=js&"
export * from "./RouterAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports